<template>
  <div>
    <header :class="{ 'fixed top-0': desktopMenuIsOpen && !isMobile }" class="w-full z-[99999] bg-white text-newColors-gray-content ellevio-header" ref="headerHeightRef">
      <ellevio-web-run-onload />
      <ellevio-web-alert v-if="alert" v-bind="alertMenu" :scrollbarWidth="scrollbarWidth" :desktopMenuIsOpen="desktopMenuIsOpen" />
      <ellevio-web-desktop-nav
        v-if="!isMobile"
        @toggleMegaMenu="handleToggleMegaMenu"
        :searchNoHitsContent="searchNoHitsContent"
        :headerHeight="headerHeight"
        :show="!isMobile"
        :searchApiUrl="searchApiUrl"
        :searchPageUrl="searchPageUrl"
        :navigationData="desktopNavigationData"
        :logoLink="logoLink"
        :scrollbarWidth="scrollbarWidth" />
      <ellevio-web-mobile-nav
        v-if="isMobile"
        :on-map-page="onMapPage"
        apiUrl="//localhost:8082/api/autocompleteItems/"
        :searchApiUrl="searchApiUrl"
        :searchPageUrl="searchPageUrl"
        :searchNoHitsContent="searchNoHitsContent"
        :showAutocompleteList="true"
        :logoLink="logoLink"
        :footerLinks="secondaryMenu"
        v-bind="{ ...mobileNavigationData, alert }" />
    </header>
  </div>
</template>

<script>
import EllevioWebMobileNav from './MobileNav.vue'
import EllevioWebAlert from './Alert.vue'
import EllevioWebRunOnload from './RunOnload.vue'
import EllevioWebDesktopNav from './DesktopNav.vue'
import getScrollbarWidth from '../../../helpers/getScrollbarWidth'

export default {
  name: 'ellevio-web-header',
  components: {
    EllevioWebDesktopNav,
    EllevioWebMobileNav,
    EllevioWebAlert,
    EllevioWebRunOnload
  },
  props: {
    translations: {
      type: Object,
      default: () => {
        return {
          search: {},
          ariaLabels: {},
          skipLinks: {}
        }
      }
    },
    searchNoHitsContent: {
      type: String,
      default: 'Sökningen gav tyvärr inga träffar. Prova gärna med andra ord eller använd vår navigation för att hitta det du söker.'
    },
    alert: {
      type: Boolean,
      default: false
    },
    logoLink: {
      type: String,
      default: '/'
    },
    searchApiUrl: {
      type: String,
      default: ''
    },
    searchPageUrl: {
      type: String,
      default: ''
    },
    megaMenu: {
      type: Array,
      default: () => []
    },
    secondaryMenu: {
      type: Array,
      default: () => []
    },
    loginMenu: {
      type: Object,
      default: () => {}
    },
    alertMenu: {
      type: Object,
      default: () => {}
    },
    otherLanguage: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      isMobile: true,
      breakpoint: '64rem',
      desktopItemsPerRow: 4,
      mobileNavigationData: { menuItems: this.megaMenu, loginMenu: this.loginMenu, otherLanguage: this.otherLanguage, translations: this.translations },
      desktopNavigationData: {
        menuItems: this.megaMenu,
        secondaryMenu: this.secondaryMenu,
        loginMenu: this.loginMenu,
        translations: this.translations,
        otherLanguage: this.otherLanguage
      },
      headerHeight: 0,
      desktopMenuIsOpen: false,
      resizeObserver: null,
      scrollbarWidth: 0
    }
  },
  computed: {
    matchMediaQuery() {
      return window.matchMedia(` (min-width: ${this.breakpoint}) `)
    },
    onMapPage() {
      return window.location.href.indexOf('projectmap') > -1
    }
  },
  methods: {
    resize: function () {
      const isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true

      this.isMobile = isMobile

      // On mobile, remove any classes that handle the open mega menu on desktop
      if (isMobile && this.desktopMenuIsOpen) {
        this.handleToggleMegaMenu(false)
      }
    },
    handleToggleMegaMenu(isOpen) {
      const htmlClassNames = ['overflow-hidden']
      const bodyClassNames = ['overflow-y-scroll', 'w-full']

      this.desktopMenuIsOpen = isOpen

      if (this.desktopMenuIsOpen) {
        // Disable background scroll when menu is open
        document.body.classList.add(...bodyClassNames)
        document.documentElement.classList.add(...htmlClassNames)

        // Prevent background content from jumping up when header gets position fixed when open
        document.body.style.paddingTop = `${this.headerHeight}px`
      } else {
        document.body.classList.remove(...bodyClassNames)
        document.documentElement.classList.remove(...htmlClassNames)

        document.body.style.paddingTop = ''
      }
    },
    onHeaderHeightResize() {
      this.headerHeight = this.$refs.headerHeightRef.clientHeight
    }
  },
  mounted() {
    this.scrollbarWidth = getScrollbarWidth()

    this.isMobile = this.matchMediaQuery ? !this.matchMediaQuery.matches : true
    this._boundedResize = this.resize.bind(this)
    window.addEventListener('resize', this._boundedResize)

    /* Listen to changes in header height. E.g. when alert banner is closed
       The header height is used to push down the mega menu to the correct position. */
    this.resizeObserver = new ResizeObserver(this.onHeaderHeightResize)
    this.resizeObserver.observe(this.$refs.headerHeightRef)
    this.onHeaderHeightResize()
  },
  unmounted() {
    window.removeEventListener('resize', this._boundedResize)

    if (this.$refs.headerHeightRef instanceof Element) {
      this.resizeObserver.unobserve(this.$refs.headerHeightRef)
    }
  }
}
</script>
